import React, { ChangeEvent, FC } from 'react'
import styles from 'styles/components/form.module.scss'
import classNames from 'classnames'

interface Props {
  hasHashtag?: boolean
  isChecked: boolean
  id: string
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
  type?: 'contained' | 'outlined'
  value: string
}

const TagCheckbox: FC<Props> = React.memo((props) => {
  const { hasHashtag = true, id, isChecked, onChange, type = 'contained', value } = props

  return (
    <label
      className={classNames({
        [styles.checkbox__tag_checked]: isChecked,
        [styles.checkbox__tag]: !isChecked && type === 'contained',
        [styles.checkbox__tag_outlined]: !isChecked && type === 'outlined',
      })}
      htmlFor={id}
    >
      <input
        className={styles.checkbox__tag__input}
        checked={isChecked}
        id={id}
        onChange={(e) => onChange(e)}
        value={value}
        type="checkbox"
      />
      <span>
        {hasHashtag && '# '}
        {value}
      </span>
    </label>
  )
})

export default TagCheckbox
